function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1162",
  "data-name": "Group 1162",
  transform: "translate(-827.875 -44.541)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_318",
  "data-name": "Group 318",
  transform: "translate(642.594 -155.792)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_117",
  "data-name": "Path 117",
  d: "M212.2,214.288a12.959,12.959,0,1,1-12.963-12.955A12.927,12.927,0,0,1,212.2,214.288Z",
  fill: "none",
  stroke: "#ff0",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_319",
  "data-name": "Group 319"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_8",
  "data-name": "Ellipse 8",
  cx: 3.508,
  cy: 3.508,
  rx: 3.508,
  ry: 3.508,
  transform: "translate(838.325 52.178)",
  fill: "none",
  stroke: "#ff0",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  d: "M195.1,224.655a5.483,5.483,0,0,1,10.965,0",
  transform: "translate(641.253 -160.044)",
  fill: "none",
  stroke: "#ff0",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
})));

var SvgProfileYellow = function SvgProfileYellow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.917,
    height: 27.918,
    viewBox: "0 0 27.917 27.918",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-yellow.605f7f13.svg";
export { ForwardRef as ReactComponent };